import React from 'react'
import { Paper, Stack, Group, Divider, Text } from '@mantine/core'
import { IconThumbUp, IconThumbDown } from '@tabler/icons-react'
import { SectionLabel } from './SectionLabel'

type PointsType = 'tops' | 'flops'
type TablerIconComponent = React.FC<{ size?: number; color?: string; stroke?: number }>

const POINTS_CONFIG: Record<PointsType, {
  icon: TablerIconComponent
  label: string
  color: string
  emptyLabel: string
}> = {
  tops: { icon: IconThumbUp, label: 'Points positifs', color: 'teal', emptyLabel: 'point positif' },
  flops: { icon: IconThumbDown, label: 'Points négatifs', color: 'red', emptyLabel: 'point négatif' },
}

function accentCard(color: string): React.CSSProperties {
  return {
    background: `var(--mantine-color-${color}-0)`,
    border: `1px solid var(--mantine-color-${color}-2)`,
  }
}

function BulletList(props: { text: string }) {
  const { text } = props
  const items = text.split(/\n|,/).map((s) => s.trim()).filter(Boolean)
  if (items.length === 1) return <Text size="sm">{items[0]}</Text>
  return (
    <Stack gap={6}>
      {items.map((item, i) => (
        <Group key={i} gap="xs" align="flex-start">
          <Text size="sm" c="dimmed" mt={2}>·</Text>
          <Text size="sm" style={{ flex: 1 }}>{item}</Text>
        </Group>
      ))}
    </Stack>
  )
}

export const PointsCard = (props: { type: PointsType; text: string | null }) => {
  const { type, text } = props
  const { icon: Icon, label, color, emptyLabel } = POINTS_CONFIG[type]
  return (
    <Paper p="lg" radius="md" style={accentCard(color)}>
      <Stack gap="sm">
        <Group gap="xs">
          <Icon size={14} color={`var(--mantine-color-${color}-7)`} stroke={2} />
          <SectionLabel>{label}</SectionLabel>
        </Group>
        <Divider color={`${color}.2`} />
        {text
          ? <BulletList text={text} />
          : <Text size="sm" c="dimmed" fs="italic">Aucun {emptyLabel} remonté pour cet avis.</Text>
        }
      </Stack>
    </Paper>
  )
}
